import { Inject, Injectable } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { Router } from '@angular/router';
import { ErrorScreenNavigation } from '@invessio/ui';
import { PermissionService } from './permission.service';

@Injectable({ providedIn: 'root' })
export class NavigationService implements ErrorScreenNavigation {
  constructor(
    private location: Location,
    private router: Router,
    private permissionService: PermissionService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  goBack(): void {
    const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';

    if (!isAuthenticated) {
      if (sessionStorage.getItem('isSelfServeError') === 'true') {
        sessionStorage.removeItem('isSelfServeError');
        const link = this.document.createElement('a');
        link.href = 'https://www.yrefyignyte.com/find-your-school';
        link.click();
        return;
      }
      this.location.back();
      return;
    }

    const defaultRoute = this.permissionService.getDefaultPostAuthUrl();
    void this.router.navigateByUrl(defaultRoute);
  }
}
